import { poll } from '@arcxmoney/arcx-react'
import { useWeb3React } from '@web3-react/core'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ConnectWallet } from 'src/components/ConnectWallet'
import { Deposit } from 'src/components/Deposit'
import { Spinner } from 'src/components/Spinner'
import { Swap } from 'src/components/Swap'
import { TabBar } from 'src/components/TabBar'
import { Title } from 'src/components/Title'
import { Withdraw } from 'src/components/Withdraw'
import { getConfigForNetwork } from 'src/config'
import { ArcContext } from 'src/contexts/ArcContext'
import { CurveService, PoolInfo } from 'src/services/CurveService'
import './CurvePage.scss'

export function CurvePage() {
  const web3context = useWeb3React()
  const { arc, network, isPlaynetActivated } = useContext(ArcContext)
  const [poolInfo, setPoolInfo] = useState<PoolInfo>()

  const curveService = useMemo(() => {
    if (!arc || !network) return
    const config = getConfigForNetwork(network, isPlaynetActivated)
    if (!config.curvePool) return
    return new CurveService(arc.signer, config.curvePool)
  }, [arc, network, isPlaynetActivated])

  useEffect(() => {
    return poll(async () => {
      const poolInfo = await curveService?.getPoolInfo()
      setPoolInfo((prevInfo) =>
        prevInfo?.toString() === poolInfo?.toString() ? prevInfo : poolInfo,
      )
    }, 5000)
  }, [curveService])

  if (!web3context.account) {
    return <ConnectWallet />
  }
  return (
    <div className="curve-page page">
      <div className="curve-page__container">
        <Title
          title="Exchange"
          description="Exchange your tokens and provide liquidity to the pool in order to earn curve STABLEx pool's lp tokens"
          className="curve-page__title"
        />
        {curveService && poolInfo ? (
          <TabBar
            headerClassName="curve-page__tab-bar-header"
            items={[
              {
                title: 'Swap',
                component: <Swap curveService={curveService} poolInfo={poolInfo} />,
              },
              {
                title: 'Deposit',
                component: <Deposit curveService={curveService} poolInfo={poolInfo} />,
              },
              {
                title: 'Withdraw',
                component: <Withdraw curveService={curveService} />,
              },
            ]}
          />
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  )
}
